export { default } from './MagazineBanner';
